import { render, staticRenderFns } from "./node-text.vue?vue&type=template&id=68492f2b&"
import script from "./node-text.vue?vue&type=script&lang=js&"
export * from "./node-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports